import * as z from "zod/v4";

export const syncShopifyOrdersStatus = {
  name: "syncShopifyOrdersStatus" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ status: z.string() }),
};
